/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {provideStorage as ɵa} from './storage';